import React from 'react'
import urlIcon from '../../../assets/icons/icon_std_url.svg'


import MarkdownHelper from "../../utils/MarkdownHelper";
import ReactMarkdown from "react-markdown";

const BrandPage = ({ campaign, partnerLogo }) => {

    return (
        <div className="brandpage-partner-information bg-white px-md py-md">
            <div>
                <div className="brandpage-partner-information-logo my-sm">
                    <img className="brandpage-partner-information-logo-img" src={partnerLogo} alt="partner logo"/>
                </div>
            </div>
            <div className="brandpage-partner-information-text">
                <div className="brandpage-partner-information-text_title noBolder">
                    <ReactMarkdown {...MarkdownHelper.headingTypes()}
                                   source={campaign.brandpage_headline_1}
                                   escapeHtml={false} />
                </div>
                <div className="brandpage-partner-information-text_copy">
                    <ReactMarkdown {...MarkdownHelper.headingTypes()}
                                   source={campaign.brandpage_text_1}
                                   escapeHtml={false} />
                </div>
                <div className="brandpage-partner-information-text_url-box">
                    <img src={urlIcon} alt="url icon"/>
                    <div className="brandpage-partner-information-text_url-text">
                        <ReactMarkdown {...MarkdownHelper.headingTypes()}
                                       source={campaign.brandpage_brand_url}
                                       escapeHtml={false} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BrandPage



// WEBPACK FOOTER //
// ./src/components/ads/brandPage/BrandPagePartnerInformation.js